module.exports = __webpack_public_path__ + "eaf077e2e9d8c00e3348b03a7cac92fe.ttf";